import {
  STATUS_ERROR,
  STATUS_INITIAL,
  STATUS_PENDING,
  STATUS_SUCCESS,
} from '~/constants';

import { ActionType, ExperienceAvailabilityState } from './model';

export const initialState: ExperienceAvailabilityState = {
  availableDays: { data: null, status: STATUS_INITIAL },
  availableTimes: {},
};

function logger(type, value = '') {
  console.info(
    `%cDispatcher: ${type} ${value ? `- ${value}` : ''}`,
    'color: #bada55;',
  );
}

function reducer(
  state: ExperienceAvailabilityState,
  action: ActionType,
): ExperienceAvailabilityState {
  switch (action.type) {
    case 'FETCH_DAYS':
      logger(action.type, 'PENDING');
      return {
        ...state,
        availableDays: { data: null, status: STATUS_PENDING },
      };
    case 'FETCH_DAYS_SUCCESS':
      logger(action.type);
      return {
        ...state,
        availableDays: { data: action.payload.data, status: STATUS_SUCCESS },
      };
    case 'FETCH_DAYS_ERROR':
      logger(action.type);
      return { ...state, availableDays: { data: null, status: STATUS_ERROR } };
    case 'RESET_DAYS':
      logger(action.type);
      return {
        ...state,
        availableDays: { data: null, status: STATUS_INITIAL },
      };
    case 'FETCH_TIMES':
      logger(action.type, action.payload.date);
      return {
        ...state,
        availableTimes: {
          ...state.availableTimes,
          [action.payload.date]: { data: null, status: STATUS_PENDING },
        },
      };
    case 'FETCH_TIMES_SUCCESS':
      logger(action.type);
      return {
        ...state,
        availableTimes: {
          ...state.availableTimes,
          [action.payload.date]: {
            data: action.payload.data,
            status: STATUS_SUCCESS,
          },
        },
      };
    case 'FETCH_TIMES_ERROR':
      logger(action.type);
      return {
        ...state,
        availableTimes: {
          ...state.availableTimes,
          [action.payload.date]: { data: null, status: STATUS_ERROR },
        },
      };
    case 'RESET_TIMES':
      logger(action.type);
      return { ...state, availableTimes: {} };
  }
}

export default reducer;
